import IpubUpload from './src/main'

/* istanbul ignore next */
IpubUpload.install = function(Vue) {
  Vue.component(IpubUpload.name, IpubUpload)
}

export default IpubUpload
